import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { MessageService } from 'primeng/api';
import { Observable, withLatestFrom } from 'rxjs';
import { PaymentMethod, PaymentMethodType } from 'src/app/core/models';
import { SetDefaultPatientPaymentMethod } from 'src/app/core/store/payment-methods/payment-methods.actions';
import { PaymentMethodsState } from 'src/app/core/store/payment-methods/payment-methods.state';
import { ApiStoreData } from 'src/app/core/store/utils';

@Component({
  selector: 'app-payment-method-radio',
  templateUrl: './payment-method-radio.component.html',
  styleUrls: ['./payment-method-radio.component.scss'],
})
export class PaymentMethodRadioComponent {
  @Input() control!: FormControl;
  @Input() name!: string;

  @Select(PaymentMethodsState.paymentMethods) paymentMethods$!: Observable<PaymentMethod[]>;
  @Select(PaymentMethodsState.setDefaultPaymentMethodState) setDefaultPaymentMethodState$!: Observable<
    ApiStoreData<null>
  >;
  @Select(PaymentMethodsState.defaultPaymentMethod) defaultPaymentMethod$!: Observable<PaymentMethod | null>;

  readonly PaymentMethodType = PaymentMethodType;

  constructor(private store: Store, private messageService: MessageService) {}

  changeDefaultPaymentMethod(event: { checked: boolean }, paymentMethodId: string) {
    const isNewDefaultSelected = event.checked;

    if (isNewDefaultSelected) {
      this.store
        .dispatch(new SetDefaultPatientPaymentMethod(paymentMethodId))
        .pipe(withLatestFrom(this.setDefaultPaymentMethodState$))
        .subscribe(([_, setDefaultPaymentMethodState]) => {
          if (setDefaultPaymentMethodState.error) {
            this.messageService.add({
              key: 'homeToast',
              severity: 'error',
              detail: 'Could not update default payment method.',
            });
          }
        });
    }
  }

  isPaymentMethodExpired(paymentMethod: PaymentMethod | null): boolean {
    return !!paymentMethod && paymentMethod.type === PaymentMethodType.CreditCard && paymentMethod.info.isExpired;
  }

  changeSelectedPaymentMethod(paymentMethodId: string) {
    this.control.setValue(paymentMethodId);
  }
}
